import { ReactNode, useState } from 'react'

import { useFlags } from 'launchdarkly-react-client-sdk'

import { Button, Flex, SlideFade, Text } from '@chakra-ui/react'
import { XMarkIcon } from '@heroicons/react/20/solid'
import {
  GreyGrey20,
  GreyGrey40,
  GreyGrey50,
  GreyGrey80,
  GreyWhite,
  Lato13Regular
} from '@sequencehq/design-tokens'

import { useCurrentContract } from 'ContractExtraction/index'

type Props = {
  assetId: string
}

export const ExtractionFeedbackWidget = ({ assetId }: Props) => {
  const { data: contractData } = useCurrentContract()

  const flags = useFlags()

  const [isVisible, setIsVisible] = useState<boolean>(true)

  if (!flags?.useContractIntakePrototype || contractData?.assetId !== assetId) {
    return null
  }

  return (
    <SlideFade
      offsetY="56px"
      in={isVisible}
      style={{
        position: 'absolute',
        bottom: 0,
        left: 0,
        zIndex: 1,
        display: 'flex',
        justifyContent: 'center',
        width: '100%'
      }}
    >
      <Flex
        backgroundColor="rgba(29, 41, 57, 0.8)"
        backdropFilter="blur(4px)"
        borderRadius="8px"
        marginBottom="8px"
        paddingY="6px"
        paddingLeft="12px"
        paddingRight="8px"
        alignItems="center"
        gap="12px"
      >
        <Text {...Lato13Regular} color={GreyGrey20}>
          Do you find the suggestions useful?
        </Text>

        <Flex gap="4px" alignItems="center">
          <Flex gap="1px" borderRadius="6px" overflow="hidden">
            <FeedbackButton
              onClick={() => {
                setIsVisible(false)
              }}
            >
              Yes
            </FeedbackButton>
            <FeedbackButton
              onClick={() => {
                setIsVisible(false)
              }}
            >
              No
            </FeedbackButton>
          </Flex>

          <Button
            variant="unstyled"
            color={GreyGrey50}
            height="fit-content"
            minW="fit-content"
            _hover={{ color: GreyWhite }}
            onClick={() => setIsVisible(false)}
          >
            <XMarkIcon width="20px" height="20px" color="inherit" />
          </Button>
        </Flex>
      </Flex>
    </SlideFade>
  )
}

type FeedbackButtonProps = {
  children: ReactNode
  onClick: () => void
}

const FeedbackButton = ({ children, onClick }: FeedbackButtonProps) => (
  <Button
    variant="unstyled"
    height="initial"
    minW="initial"
    {...Lato13Regular}
    color={GreyGrey40}
    background={GreyGrey80}
    borderRadius="2px"
    paddingLeft="6px"
    paddingRight="6px"
    paddingY="4px"
    _hover={{ color: GreyWhite }}
    onClick={onClick}
  >
    {children}
  </Button>
)
